
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
import env from '@/.env.json';

import {sortDirections} from '~/plugins/enums/sort';

import AddNewReview from '@/components/catalog/reviews/AddNew';
import ReviewItem from '@/components/catalog/reviews/Item';
import Alert from '@/components/elements/Alert';
import Button from '@/components/elements/Button';
import ShowMoreButton from '~/components/elements/ShowMoreButton';
import CustomSelect from '~/components/elements/CustomSelect';
import CustomRate from '~/components/elements/CustomRate';


export default {
  name: 'ReviewsWrapper',
  components: {
    CustomRate,
    CustomSelect,
    ShowMoreButton,
    AddNewReview,
    Alert,
    Button,
    ReviewItem,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    const reviewsSortDirections = [
      {
        id: 1,
        label: 'Cначала новые',
        value: sortDirections.DESC,
      },
      {
        id: 2,
        label: 'Cначала старые',
        value: sortDirections.ASC,
      },
    ];

    return {
      isShowNewReviewForm: false,
      reviewsSortDirections,
      selectedSortDirection: reviewsSortDirections[0],
      marketplaceName: env.MARKETPLACE_NAME,
      reviewAlerts: {},
    };
  },
  computed: {
    ...mapState('auth', ['hasSession', 'user']),
    ...mapState('productReviews', ['reviews', 'activePage', 'isLoading']),

    ...mapGetters({
      pagesCount: 'productReviews/pagesCount',
    }),
  },
  watch: {
    selectedSortDirection(newValue) {
      this.fetchReviews( this.product.code, this.type, {
        sortDirection: newValue.value,
      })
    },
  },
  methods: {
    ...mapMutations('auth', {
      setIsOpenedAuthModal: 'SET_IS_OPENED_AUTH_MODAL',
    }),
    ...mapActions({
      fetchReviewsData: 'productReviews/fetchReviewsData',
      getPermissionForReviews: 'productReviews/getPermissionForReviews',
    }),

    addReviewAlert({ key, content, type }) {
      this.$set(this.reviewAlerts, key, { key, content, type })
    },
    removeReviewAlert(key) {
      this.$delete(this.reviewAlerts, key)
    },
    async addNewReviewHandler() {
      const resp = await this.getPermissionForReviews({ code: this.product.code })

      if (!this.hasSession) {
        this.setIsOpenedAuthModal(true);
        return
      }

      if (resp) {
        this.isShowNewReviewForm = true
        return;
      }

      this.addReviewAlert({
        key: 'canNotSend',
        type: 'error',
        content: `Чтобы оставить отзыв, необходимо приобрести данный товар на маркетплейсе ${this.marketplaceName}`,
      })
    },
    hideNewReviewForm() {
      this.isShowNewReviewForm = false;
      this.addReviewAlert({
        key: 'moderate',
        type: 'success',
        content: 'Отзыв отправлен на модерацию',
      })
    },
    errorHandler(error) {
      this.addReviewAlert({
        key: 'error',
        type: 'error',
        content: error,
      })
    },
    async fetchReviews(code, type, filter = {}, showMore = false ) {
      await this.fetchReviewsData({code, type, filter, showMore})
    },
    async onShowMoreReviews() {
      try {
        const filter = {
          page: this.activePage + 1,
          sortDirection: this.selectedSortDirection.value,
        }

        await this.fetchReviews(this.product.code, this.type, filter, true)
      } catch (error) {
      }
    },
  },
};
